export default {
  translation: {
    common: {
      emailOrUsername: 'E-mail atau username',
      invalidEmailOrUsername: 'E-mail atau username salah',
      invalidPassword: 'Kata sandi salah',
      noInternetConnection: 'Tidak ada koneksi internet',
      pageNotFound_title: 'Halaman Tidak Ditemukan',
      password: 'Kata sandi',
      projectManagement: 'Manajemen projek',
      serverConnectionFailed: 'Koneksi server gagal',
      unknownError: 'Kesalahan tidak diketahui, coba lagi nanti.',
      useSingleSignOn: 'Gunakan single sign-on',
    },

    action: {
      logIn: 'Masuk',
      logInWithSSO: 'Masuk dengan SSO',
    },
  },
};
